<!--
 * @Description: 
 * @Author: fal
 * @Date: 2025-02-27 10:53:49
 * @FilePath: \xhlz_pc\src\project\components\viewAgreement.vue
 * @LastEditTime: 2025-09-08 15:13:26
-->
<template>
  <el-dialog title="协议查看" :visible="visible" width="70%" center :close-on-click-modal="false" append-to-body :before-close="handleClose" @open="init">
    <div style="height: 750px; overflow: scroll">
      <p v-html="agreement" style="white-space: pre-wrap"></p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="handleClose">确认并继续</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'viewAgreement',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 0：个人注册 1: 公司注册 信华利筑用户服务协议  2：项目注册 用户服务协议 3：邀请码申请 开通代理协议
    type: {
      type: Number | String,
      default: 0,
    },
  },

  data() {
    return {
      agreement: '',
      // argMap: {
      // 1: 'project_treaty', //项目注册协议
      // 2: 'prise_treaty', //企业注册协议
      // 3: 'user_agreement', //用户服务协议
      // 4: 'privacy', //隐私政策
      // 5: 'agent_agreement', //开通代理协议
      // },
    };
  },
  methods: {
    init() {
      this.$request
        .post('/collective/select/protocol')
        .then((res) => {
          this.agreement = res[this.type].content;
        })
        .catch((err) => {});
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style></style>
